export default {"src":"/_next/static/media/mail.a8e83632.svg","height":47,"width":47};